"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalClose = exports.ModalFooter = exports.ModalBody = exports.ModalHeader = exports.ModalContent = exports.ModalTrigger = exports.Modal = void 0;
const react_1 = __importStar(require("react"));
const react_dom_1 = __importDefault(require("react-dom"));
const utils_1 = require("../utils"); // Utility function for conditional class names.
// Define the context structure for the modal
const ModalContext = (0, react_1.createContext)(null);
// Modal provides context for its child components
const Modal = ({ children, initialOpen = false }) => {
    const [isOpen, setIsOpen] = (0, react_1.useState)(initialOpen);
    const openModal = () => setIsOpen(true);
    const closeModal = () => setIsOpen(false);
    return (react_1.default.createElement(ModalContext.Provider, { value: { isOpen, openModal, closeModal } }, children));
};
exports.Modal = Modal;
// ModalTrigger to open the modal
const ModalTrigger = ({ children, asChild }) => {
    const context = (0, react_1.useContext)(ModalContext);
    if (!context)
        throw new Error("ModalTrigger must be used within a Modal");
    const { openModal } = context;
    if (asChild && react_1.default.isValidElement(children)) {
        return react_1.default.cloneElement(children, {
            onClick: openModal,
        });
    }
    return (react_1.default.createElement("button", { onClick: openModal, className: (0, utils_1.cn)("inline-flex items-center justify-center px-4 py-2 bg-blue-600 text-brandWhite rounded-md") }, children));
};
exports.ModalTrigger = ModalTrigger;
// ModalContent displays modal content
const ModalContent = ({ children, className }) => {
    const context = (0, react_1.useContext)(ModalContext);
    if (!context)
        throw new Error("ModalContent must be used within a Modal");
    const { isOpen, closeModal } = context;
    const modalRef = (0, react_1.useRef)(null);
    const triggerRef = (0, react_1.useRef)(null);
    (0, react_1.useEffect)(() => {
        const focusableSelectors = [
            "a[href]",
            "button",
            "textarea",
            "input[type='text']",
            "input[type='radio']",
            "input[type='checkbox']",
            "select",
            "[tabindex]:not([tabindex='-1'])",
        ];
        const handleFocusTrap = (event) => {
            if (event.key === "Tab") {
                const focusableElements = modalRef.current
                    ? Array.from(modalRef.current.querySelectorAll(focusableSelectors.join(",")))
                    : [];
                if (focusableElements.length === 0)
                    return;
                const firstElement = focusableElements[0];
                const lastElement = focusableElements[focusableElements.length - 1];
                if (event.shiftKey && document.activeElement === firstElement) {
                    event.preventDefault();
                    lastElement.focus();
                }
                else if (!event.shiftKey && document.activeElement === lastElement) {
                    event.preventDefault();
                    firstElement.focus();
                }
            }
        };
        const handleKeyDown = (event) => {
            if (event.key === "Escape") {
                document.body.style.touchAction = '';
                closeModal();
            }
        };
        if (isOpen) {
            // triggerRef.current = document.activeElement as HTMLElement;
            // modalRef.current?.focus();
            document.addEventListener("keydown", handleKeyDown);
            document.addEventListener("keydown", handleFocusTrap);
            document.body.style.overflow = "hidden";
        }
        else {
            triggerRef.current?.focus();
            document.body.style.overflow = "";
            document.body.style.touchAction = '';
        }
        return () => {
            document.removeEventListener("keydown", handleKeyDown);
            document.removeEventListener("keydown", handleFocusTrap);
            document.body.style.overflow = "";
        };
    }, [isOpen, closeModal]);
    const handleOverlayClick = (event) => {
        if (event.target === event.currentTarget) {
            closeModal();
        }
    };
    if (!isOpen)
        return null;
    return react_dom_1.default.createPortal(react_1.default.createElement("div", { role: "dialog", "aria-modal": "true", className: (0, utils_1.cn)("fixed inset-0 z-50 flex items-center justify-center bg-brandBlack/50 backdrop-blur-sm"), onClick: handleOverlayClick },
        react_1.default.createElement("div", { ref: modalRef, tabIndex: -1, className: (0, utils_1.cn)("bg-white p-6 rounded-lg shadow-xl w-full max-w-md transform transition-transform scale-100 animate-modal-scale", className) }, children)), document.body);
};
exports.ModalContent = ModalContent;
// ModalHeader for header content
const ModalHeader = ({ children, className }) => (react_1.default.createElement("header", { className: (0, utils_1.cn)("flex justify-between items-center border-b pb-2", className) }, children));
exports.ModalHeader = ModalHeader;
// ModalBody for main body content
const ModalBody = ({ children, className }) => (react_1.default.createElement("div", { className: (0, utils_1.cn)("mt-4", className) }, children));
exports.ModalBody = ModalBody;
// ModalFooter for footer content
const ModalFooter = ({ children, className }) => (react_1.default.createElement("footer", { className: (0, utils_1.cn)("mt-6 flex justify-end border-t pt-2", className) }, children));
exports.ModalFooter = ModalFooter;
// ModalClose to close the modal
const ModalClose = ({ asChild, children }) => {
    const context = (0, react_1.useContext)(ModalContext);
    if (!context)
        throw new Error("ModalClose must be used within a Modal");
    const { closeModal } = context;
    if (asChild && react_1.default.isValidElement(children)) {
        return react_1.default.cloneElement(children, {
            onClick: closeModal,
        });
    }
    return (react_1.default.createElement("button", { onClick: closeModal, "aria-label": "Close", className: (0, utils_1.cn)("text-grey400 hover:text-grey600") }, "\u2715"));
};
exports.ModalClose = ModalClose;
